var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ListHistoric',{attrs:{"campaign_id":_vm.campaign_id},on:{"view-changes":_vm.changeInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }